/**
 * EM Klaviyo form trigger
 * Opens form STppBr when any link with href="#klaviyo-form" is clicked
 * (e.g. announcement bar hash link).
 */
(() => {
  const HASH = "#klaviyo-form";
  const FORM_ID = "STppBr";

  document.addEventListener(
    "click",
    (event) => {
      const link = event.target.closest(`a[href="${HASH}"]`);
      if (!link) return;
      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", FORM_ID]);
    },
    true
  );
})();
